import src from "IMAGE";
export default { src, width: 369, height: 481, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
